import { Grid, styled } from "@mui/material";

export const StyledBorderedCard = styled(Grid)(({ theme }) => ({
  border: `1px solid ${theme.palette.custom.border_gray}`,
  borderRadius: theme.shape.borderRadius[2],
}));
